export default "__VITE_ASSET__Yd1GCU1Q__"